import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { InfiniteScroll } from 'mint-ui'
import 'mint-ui/lib/style.css'
import VueBus from './utils/vueBus'
import VueClipboard from 'vue-clipboard2'
import { getWechatSdk } from '@/data/api'
import { setTimeout } from 'core-js'
import permission from './utils/permission'

Vue.config.productionTip = false
Vue.use(InfiniteScroll)
Vue.use(VueBus)
Vue.use(VueClipboard)

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  store.commit('hanleRoute', to.name)
  // next()
  permission(next)
})

router.afterEach((to, from) => {
  // 采用定时器是解决触发该狗子时location.href还是之前那个url路径
  // ios配置的路径要是刚打开时的路径
  // 安卓配置的路径要是每个页面实际的路径
  setTimeout(() => {
    const locationurl = location.href
    let url = ''
    if (/\(i[^;]+;( U;)? CPU.+Mac OS X/.test(window.navigator.userAgent)) {
      // ios
      if (store.state.iosJssdkUrl) {
        url = store.state.iosJssdkUrl
      } else {
        url = locationurl
        store.commit('setIosUrl', locationurl)
      }
    } else {
      // anzhuo
      url = locationurl
    }
    getWechatSdk(url).then(res => {
      const { data: { appId, nonceStr, signature, timestamp } } = res
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId, // 必填，公众号的唯一标识
        timestamp, // 必填，生成签名的时间戳
        nonceStr, // 必填，生成签名的随机串
        signature, // 必填，签名
        jsApiList: ['chooseImage', 'updateAppMessageShareData', 'onMenuShareAppMessage', 'chooseWXPay'] // 必填，需要使用的JS接口列表
      })
    })
  }, 100)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
